import { format } from 'date-fns';
import { DEFAULT_DATE_FORMAT } from 'utils/parseDate';

export const formatDateStringInput = (value: Date) => {
    if (value === null || isNaN(value.getTime())) {
        return '';
    }
    return format(value, DEFAULT_DATE_FORMAT);
};
